import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-occupancy-icon',
  templateUrl: './occupancy-icon.component.html',
  styles: []
})
export class OccupancyIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
